export const bookingStatusUpdateSucceeded = (response) => (
  response?.success === true
  || response?.success === 1
  || response?.success === '1'
  || response?.status === 'success'
);

export const isBookingStatusMismatch = (response) => (
  typeof response?.message === 'string'
  && response.message.startsWith('Booking status mismatch.')
);

export const executeBookingStatusUpdate = async (request) => {
  try {
    const response = await request();
    return {
      ok: bookingStatusUpdateSucceeded(response),
      response,
      message: response?.message || 'Failed to update booking status',
      requestFailed: false,
    };
  } catch (error) {
    return {
      ok: false,
      error,
      message: error?.message || 'Failed to update booking status',
      requestFailed: true,
    };
  }
};
